import { z } from 'zod';

import { BrowserSessionStatusSchema } from './channel-connection';

export const FACEBOOK_GROUP_LIVE_KEYS = [
  'Enter',
  'Backspace',
  'Tab',
  'Escape',
  'ArrowUp',
  'ArrowDown',
  'ArrowLeft',
  'ArrowRight',
] as const;

export const FacebookGroupLiveInputSchema = z.discriminatedUnion('type', [
  z.object({ type: z.literal('click'), x: z.number().min(0), y: z.number().min(0) }),
  z.object({ type: z.literal('text'), text: z.string().min(1).max(2000) }),
  z.object({ type: z.literal('key'), key: z.enum(FACEBOOK_GROUP_LIVE_KEYS) }),
  z.object({ type: z.literal('scroll'), deltaY: z.number().min(-5000).max(5000) }),
  z.object({ type: z.literal('navigate'), url: z.url() }),
]);
export type FacebookGroupLiveInput = z.infer<typeof FacebookGroupLiveInputSchema>;

export const FacebookGroupLiveFrameSchema = z.object({
  image: z.string(),
  width: z.number().int().positive(),
  height: z.number().int().positive(),
  url: z.string(),
  leaseExpiresAt: z.iso.datetime(),
});
export type FacebookGroupLiveFrame = z.infer<typeof FacebookGroupLiveFrameSchema>;

export const FacebookGroupLiveSessionSchema = z.object({
  sessionStatus: BrowserSessionStatusSchema,
  leaseExpiresAt: z.iso.datetime().nullable(),
});
export type FacebookGroupLiveSession = z.infer<typeof FacebookGroupLiveSessionSchema>;
